import EmplifiFeedback from '../EmplifiFeedback/emplifi-feedback';
import React from 'react';

interface Props {
    topicResponse: any;
}

const astuteTopicEmplifiFeedback = (props: Props) => {
    return (
        <>
            {props.topicResponse.data?.topicId &&
            props.topicResponse.data?.topicId > 0 ? (
                <EmplifiFeedback
                    topicId={props.topicResponse.data?.topicId}
                    sessionId={props.topicResponse.data?.sessionId || ''}
                />
            ) : (
                <></>
            )}
        </>
    );
};
export default astuteTopicEmplifiFeedback;
